import React from 'react';
import snowflake from '../assets/snowflake.png';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

// Snowflake component
const Snowflake: React.FC<{
  size: string;
  opacity: string;
  animation: string;
  duration: string;
  left: string;
  color: string;
}> = ({ size, opacity, animation, duration, left, color }) => (
  <div
    className={`absolute ${size} ${opacity} z-10`}
    style={{
      animation: `${animation} ${duration} linear infinite`,
      left,
      top: '0px',
    }}
  >
    <div className={`w-full h-full ${color} rounded-full shadow-sm`}></div>
  </div>
);

// Image Snowflake component
const ImageSnowflake: React.FC<{
  size: string;
  opacity: string;
  animation: string;
  duration: string;
  left: string;
}> = ({ size, opacity, animation, duration, left }) => (
  <div
    className={`absolute ${size} ${opacity} z-10`}
    style={{
      animation: `${animation} ${duration} linear infinite`,
      left,
      top: '0px',
    }}
  >
    <img
      src={snowflake}
      alt="snowflake"
      className="w-full h-full object-contain"
    />
  </div>
);

// Skater component
const Skater: React.FC<{
  size: string;
  opacity: string;
  animation: string;
  duration: string;
  bottom: string;
  color: string;
}> = ({ size, opacity, animation, duration, bottom, color }) => (
  <div
    className={`absolute ${size} ${opacity} z-0`}
    style={{
      animation: `${animation} ${duration} linear infinite`,
      bottom,
    }}
  >
    <div className={`w-full h-full ${color} rounded-full shadow-sm`}></div>
  </div>
);

// Snowflake configuration data
const snowflakeConfig = [
  {
    size: 'w-4 h-4',
    opacity: 'opacity-80',
    animation: 'snowfall-1',
    duration: '8s',
    left: '10%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-2 h-2',
    opacity: 'opacity-60',
    animation: 'snowfall-2',
    duration: '12s',
    left: '20%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-90',
    animation: 'snowfall-3',
    duration: '6s',
    left: '35%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-3 h-3',
    opacity: 'opacity-70',
    animation: 'snowfall-4',
    duration: '10s',
    left: '50%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-85',
    animation: 'snowfall-5',
    duration: '7s',
    left: '65%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-2 h-2',
    opacity: 'opacity-65',
    animation: 'snowfall-1',
    duration: '11s',
    left: '80%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-3 h-3',
    opacity: 'opacity-75',
    animation: 'snowfall-2',
    duration: '9s',
    left: '15%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-2.5 h-2.5',
    opacity: 'opacity-80',
    animation: 'snowfall-3',
    duration: '13s',
    left: '30%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-95',
    animation: 'snowfall-4',
    duration: '5s',
    left: '45%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-2 h-2',
    opacity: 'opacity-55',
    animation: 'snowfall-5',
    duration: '14s',
    left: '60%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-90',
    animation: 'snowfall-1',
    duration: '8.5s',
    left: '75%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-3 h-3',
    opacity: 'opacity-70',
    animation: 'snowfall-2',
    duration: '10.5s',
    left: '90%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-2 h-2',
    opacity: 'opacity-50',
    animation: 'snowfall-3',
    duration: '9.5s',
    left: '25%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-3 h-3',
    opacity: 'opacity-75',
    animation: 'snowfall-4',
    duration: '7.5s',
    left: '40%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-1.5 h-1.5',
    opacity: 'opacity-60',
    animation: 'snowfall-5',
    duration: '11.5s',
    left: '55%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-85',
    animation: 'snowfall-1',
    duration: '6.5s',
    left: '70%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-2.5 h-2.5',
    opacity: 'opacity-70',
    animation: 'snowfall-2',
    duration: '12.5s',
    left: '85%',
    color: 'bg-[#e6f0f5]',
  },
];

// Image Snowflake configuration data
const imageSnowflakeConfig = [
  {
    size: 'w-6 h-6',
    opacity: 'opacity-70',
    animation: 'snowfall-1',
    duration: '9s',
    left: '5%',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-60',
    animation: 'snowfall-2',
    duration: '13s',
    left: '15%',
  },
  {
    size: 'w-7 h-7',
    opacity: 'opacity-80',
    animation: 'snowfall-3',
    duration: '7s',
    left: '25%',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-65',
    animation: 'snowfall-4',
    duration: '11s',
    left: '40%',
  },
  {
    size: 'w-3 h-3',
    opacity: 'opacity-75',
    animation: 'snowfall-5',
    duration: '8s',
    left: '55%',
  },
  {
    size: 'w-6 h-6',
    opacity: 'opacity-70',
    animation: 'snowfall-1',
    duration: '12s',
    left: '70%',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-60',
    animation: 'snowfall-2',
    duration: '10s',
    left: '85%',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-80',
    animation: 'snowfall-3',
    duration: '14s',
    left: '95%',
  },
];

// Skater configuration data
const skaterConfig = [
  {
    size: 'w-8 h-8',
    opacity: 'opacity-15',
    animation: 'skate-figure-1',
    duration: '12s',
    bottom: '20%',
    color: 'bg-blue-100',
  },
  {
    size: 'w-6 h-6',
    opacity: 'opacity-12',
    animation: 'skate-figure-2',
    duration: '10s',
    bottom: '30%',
    color: 'bg-indigo-100',
  },
  {
    size: 'w-7 h-7',
    opacity: 'opacity-14',
    animation: 'skate-figure-3',
    duration: '14s',
    bottom: '15%',
    color: 'bg-slate-100',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-10',
    animation: 'skate-figure-4',
    duration: '8s',
    bottom: '35%',
    color: 'bg-blue-50',
  },
  {
    size: 'w-6 h-6',
    opacity: 'opacity-13',
    animation: 'skate-figure-5',
    duration: '11s',
    bottom: '25%',
    color: 'bg-indigo-50',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-08',
    animation: 'skate-figure-6',
    duration: '9s',
    bottom: '40%',
    color: 'bg-blue-50',
  },
  {
    size: 'w-7 h-7',
    opacity: 'opacity-16',
    animation: 'skate-figure-7',
    duration: '13s',
    bottom: '12%',
    color: 'bg-indigo-100',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-11',
    animation: 'skate-figure-8',
    duration: '7s',
    bottom: '28%',
    color: 'bg-slate-50',
  },
  {
    size: 'w-6 h-6',
    opacity: 'opacity-14',
    animation: 'skate-figure-9',
    duration: '15s',
    bottom: '18%',
    color: 'bg-blue-100',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-09',
    animation: 'skate-figure-10',
    duration: '6s',
    bottom: '32%',
    color: 'bg-indigo-50',
  },
  {
    size: 'w-8 h-8',
    opacity: 'opacity-17',
    animation: 'skate-figure-11',
    duration: '16s',
    bottom: '8%',
    color: 'bg-slate-100',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-12',
    animation: 'skate-figure-12',
    duration: '10.5s',
    bottom: '22%',
    color: 'bg-blue-50',
  },
  {
    size: 'w-6 h-6',
    opacity: 'opacity-13',
    animation: 'skate-figure-13',
    duration: '12.5s',
    bottom: '38%',
    color: 'bg-indigo-100',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-10',
    animation: 'skate-figure-14',
    duration: '8.5s',
    bottom: '16%',
    color: 'bg-slate-50',
  },
  {
    size: 'w-7 h-7',
    opacity: 'opacity-15',
    animation: 'skate-figure-15',
    duration: '11.5s',
    bottom: '26%',
    color: 'bg-blue-100',
  },
];

const ContainerLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <div className="flex min-h-screen">
      {/* Main Content */}
      <div className="w-full flex flex-col flex-grow relative overflow-hidden pt-16">
        {/* Snowflakes */}
        {snowflakeConfig.map((config, index) => (
          <Snowflake key={index} {...config} />
        ))}

        {/* Image Snowflakes */}
        {imageSnowflakeConfig.map((config, index) => (
          <ImageSnowflake key={index} {...config} />
        ))}

        {/* Skating Figures */}
        {skaterConfig.map((config, index) => (
          <Skater key={index} {...config} />
        ))}

        <Navbar />

        {/* Banner */}
        <div
          className="w-full py-2 sm:py-14 relative z-10"
          // style={{ backgroundColor: '#458FAE' }}
          // style={{ backgroundColor: '#3a65c9' }}
          style={{ backgroundColor: '#cddfe5' }}
        />

        {/* Clean Container */}
        <div className="container mx-auto border bg-white backdrop-blur-sm rounded-2xl sm:rounded-3xl lg:rounded-[2rem] shadow-2xl -mt-2 sm:-mt-20 min-h-[90vh] flex flex-col sm:max-w-[90%] md:max-w-2xl lg:max-w-3xl xl:max-w-4xl 2xl:max-w-5xl relative z-10">
          <div className="flex flex-col sm:flex-row h-full flex-grow rounded-full sm:rounded-3xl lg:rounded-[2rem]">
            {/* Main Content Area */}
            <div className="flex-1 min-w-0 rounded-full sm:rounded-3xl lg:rounded-[2rem] p-4 md:p-6 lg:p-10">
              <div className="min-h-screen bg-gray-50 py-2 md:py-8 sm:rounded-3xl lg:rounded-[2rem]">
                {children}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ContainerLayout;
